import React, { useState } from 'react'
import { Classes, Divider, InputGroup } from '@blueprintjs/core'
import { Dialog } from '@ui'
import { IconButton, Button, Toaster } from '@ui'
import api from '@api'
import { useReload } from '@hooks/reloadContext'
import { pluralize } from '@utils'
type BookingCancelDialogProps = {
  cancelIds: string[]
  onClose: () => void
}
const BookingCancelDialog: React.FunctionComponent<BookingCancelDialogProps> = ({
  cancelIds,
  onClose,
}: BookingCancelDialogProps) => {
  const [signature, setSignature] = useState('')
  const [loading, setLoading] = useState(false)
  const { bookings } = useReload()

  const content = `Hi, 
                
  Your desk reservation has been cancelled.`

  const subject = 'Your desk reservation has been cancelled.'

  return (
    <Dialog
      title="Cancellation Notification"
      isOpen
      usePortal
      style={{ minWidth: 600 }}
      toolbar={
        <div className="dialog-buttons">
          <IconButton minimal iconName="times" onClick={() => onClose()} />
        </div>
      }
      body={
        <div className={Classes.DIALOG_BODY}>
          <p className="my-2 text-grey-500">
            Email is sent to selected employees, notifying them of their booking cancellation
          </p>
          <div className="flex flex-col">
            <div className="flex mb-2">
              <div className="w-32 py-1">Email Subject</div>
              <div className="pl-3 pr-32 py-1 ">
                <p className="mr-6">{subject}</p>
              </div>
            </div>
            <div className="flex mb-2">
              <div className="w-32 py-1">Email Content</div>
              <div className="pl-3 pr-32 py-1">
                <p className="whitespace-pre-line mr-6">
                  {`${content} 

          [Booking Details]

          Thanks,`}
                </p>
                <p>{}</p>
                <InputGroup
                  placeholder="The Eptura Team"
                  value={signature}
                  onChange={({ currentTarget: { value } }: React.FormEvent<HTMLInputElement>) =>
                    setSignature(value)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      }
      footer={
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text={pluralize(cancelIds.length, 'Cancel Booking') + ' & Send Notification'}
              blue
              loading={loading}
              onClick={() => {
                setLoading(true)
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                api.booking.cancel
                  .bookings({
                    subject,
                    content,
                    signature: `Thanks, \n${signature.length ? signature : 'The Eptura Team'}`,
                    bookingIds: cancelIds,
                  })
                  .then(() => {
                    Toaster.success({
                      message: pluralize(cancelIds.length, 'Booking') + ' cancelled',
                    })
                    bookings()
                    onClose()
                    setLoading(false)
                  })
              }}
            />
          </div>
        </div>
      }
    />
  )
}
export default BookingCancelDialog
